<script setup lang="ts">
import { computed } from 'vue'
import { ExchangeRate } from '~/components/ui/exchange-rate'

interface CurrencyRate {
  buyValue: number | null
  sellValue: number | null
}

interface ExchangeRatesData {
  usd: CurrencyRate
  eur: CurrencyRate
  kzt: CurrencyRate
  rub: CurrencyRate
  cny?: CurrencyRate
}

interface Props {
  rates: ExchangeRatesData
}

const props = defineProps<Props>()

const fitData = computed(() => {
  const entries = Object.entries(props.rates).filter(([, val]) => val.buyValue !== null)

  if (entries.length === 0) return {}

  const limitedEntries = entries.slice(0, 4)

  return Object.fromEntries(limitedEntries)
})
</script>

<template>
  <section
    class="relative flex flex-col items-center space-y-5 rounded-lg bg-gray-100 p-4 sm:flex-row sm:justify-between sm:space-x-8 sm:space-y-0"
  >
    <div class="flex w-full justify-between">
      <ExchangeRate
        v-for="(currency, index, number) in fitData"
        :key="index"
        :currency="index.toString()"
        :current-value="currency.buyValue"
        :class="{ 'lg:hidden xl:flex': number === Object.keys(props.rates).length - 1 }"
      />
    </div>
    <Button
      variant="link"
      size="auto"
      class="md:ml-auto md:after:absolute md:after:inset-0"
      as-child
    >
      <NuxtLinkLocale to="/rates">{{ $t('common.view_all_rates') }}</NuxtLinkLocale>
    </Button>
  </section>
</template>
